import React from 'react'
import { Select, Typography } from 'antd'

const { Text } = Typography

interface ColumnSelectorProps {
  options: any[]
  value: string[]
  onChange: (value: string[]) => void
  placeholder?: string
}

const ColumnSelector: React.FC<ColumnSelectorProps> = ({ 
  options, 
  value, 
  onChange, 
  placeholder = "Choose metrics to display..." 
}) => {
  const handleChange = (newValue: string[]) => {
    // Get all disabled/locked columns that should always be included
    const lockedColumns = options
      .filter(option => option.disabled)
      .map(option => option.value)
    
    // Ensure locked columns are always included
    const combinedValues = [...lockedColumns, ...newValue]
    const updatedValue = Array.from(new Set(combinedValues))
    
    onChange(updatedValue)
  }

  return (
    <div className="flex items-center gap-2">
      <Text type="secondary" className="text-sm font-medium whitespace-nowrap">
        Show columns:
      </Text>
      <Select
        className="w-72 [&_.ant-select-selector]:!border-gray-300 [&_.ant-select-selector]:!rounded-lg [&_.ant-select-selector]:!shadow-sm hover:[&_.ant-select-selector]:!border-blue-400 focus:[&_.ant-select-selector]:!border-blue-500 focus:[&_.ant-select-selector]:!ring-2 focus:[&_.ant-select-selector]:!ring-blue-100"
        mode="multiple"
        placeholder={placeholder}
        options={options}
        value={value}
        onChange={handleChange}
        maxTagCount="responsive"
        size="middle"
        allowClear
        showSearch={false}
      />
    </div>
  )
}

export default ColumnSelector